import { Box, Typography } from "@mui/material";
import CustomToolTip from "../../../../components/CustomTooltip";
import SvgToIcon from "../../../../icons/SvgToIcon";
import { icons } from "../../../stack/environment/icons/iconExport";

// Matches VulnerabilityTargetType in backend
export const VulnerabilityTargetType = {
  ENDPOINT: "endpoint",
  SERVER: "server",
  CONTAINER: "container",
  SERVERLESS: "serverless",
  DATASTORE: "datastore",
};

export const VulnerabilityTargetTypeToDisplayName = {
  endpoint: "Endpoint",
  server: "Server",
  container: "Container",
  serverless: "Serverless",
  datastore: "Datastore",
};

export const VulnerabilityTargetTypeToIcon = {
  endpoint: icons.endpointsIcon,
  server: icons.serversIcon,
  container: icons.containerIcon,
  serverless: icons.serverlessIcon,
  datastore: icons.databaseIcon,
};

export const TargetTypesRowFilter = ({ targetType }) => {
  return (
    <Box
      display={"flex"}
      flexDirection={"row"}
      alignItems={"center"}
      justifyContent={"space-around"}
    >
      <SvgToIcon
        IconLogo={VulnerabilityTargetTypeToIcon[targetType]}
        width={"20px"}
      />
      <Typography
        variant="caption"
        style={{
          textTransform: "none",
          fontSize: "12px",
          paddingLeft: "8px",
        }}
      >
        {VulnerabilityTargetTypeToDisplayName[targetType]}
      </Typography>
    </Box>
  );
};

export const TargetTypesCell = ({ targetTypes }) => {
  const maxTargetTypesDisplay = 3;

  return (
    <>
      {targetTypes.length > 0 ? (
        <Box display="flex" alignItems="center" gap={1.5}>
          {targetTypes
            .map((targetType) => (
              <CustomToolTip
                title={
                  <Typography variant="caption">
                    {VulnerabilityTargetTypeToDisplayName[targetType]}
                  </Typography>
                }
              >
                <Box display="flex" alignItems="center" gap={1.5}>
                  <SvgToIcon
                    IconLogo={VulnerabilityTargetTypeToIcon[targetType]}
                    width={"20px"}
                  />
                </Box>
              </CustomToolTip>
            ))
            .slice(0, maxTargetTypesDisplay)}
          {targetTypes.length > maxTargetTypesDisplay
            ? `+${targetTypes.length - maxTargetTypesDisplay}`
            : null}
        </Box>
      ) : (
        <CustomToolTip
          title={
            <Typography variant="caption">
              No Compensating Controls available
            </Typography>
          }
        >
          <Typography variant="caption">N/A</Typography>
        </CustomToolTip>
      )}
    </>
  );
};
